import React, { useState, useEffect } from "react"
import BoundInOut from "./tabs/boundInOut"
import Setting from "./tabs/setting"
import { formatFaxNumber } from "./../utils/common"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/airbnb.css"
import { PERSONAL_FAX } from "./../utils/constants"
import Select from "react-select"
import { UserCheck } from "lucide-react"

const filterByFields = [
  {
    value: "",
    label: "-- Search By --",
  },
  {
    value: "originating_fax_tsid",
    label: "Fax Number",
  },
  {
    value: "copiedToSubfolder",
    label: "Copied To",
  },
  {
    value: "fax_id",
    label: "Fax Id",
  },
  {
    value: "comment",
    label: "Comment",
  },
  {
    value: "date",
    label: "Date",
  },
]

const FaxList = ({
  selectedFax,
  setSelectedFax,
  selectedQueue,
  tab,
  setTab,
  tabs,
  authUser,
  reloadQueues,
  queueList,
  practicesLength,
  allPermissions,
  setSelectedQueue,
  setReloadSubfolderCount,
  outboundFaxOnlySetting,
}) => {
  const [searchBy, setSearchBy] = useState("")
  const [searchText, setSearchText] = useState("")
  const [dateRange, setDateRange] = useState([])
  const [selectedDate, setSelectedDate] = useState(null)
  const [reloadKey, setReloadKey] = useState(0)
  const [toggleOwnAPPSender, setToggleOwnAPPSender] = useState(false)

  // datepicker
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(today.getDate() - 1)
  const twoDaysAgo = new Date()
  twoDaysAgo.setDate(today.getDate() - 2)

  const past180Days = new Date()
  past180Days.setDate(today.getDate() - 3654)

  const handleTabClick = (key) => {
    setTab(key) // Update selected tab on click
  }

  const containerFlex =
    tab === "setting" ? "0 0 80%" : selectedFax ? "0 0 55%" : "0 0 80%"

  const filteredTabs = tabs.filter((t) => {
    if (selectedQueue?.type === "subfolder" && t.key === "outbound") {
      return false
    }

    if (
      (selectedQueue?.faxNumber === PERSONAL_FAX ||
        selectedQueue?.parentKey === "userPersonalFax") &&
      (t.key === "inbound" || t.key === "setting")
    ) {
      return false
    }

    if (
      outboundFaxOnlySetting &&
      t.key === "inbound" &&
      selectedQueue?.type !== "subfolder"
    ) {
      return false
    }

    return true
  })

  // 🚫 Don't render if practice is not selected and not on "setting"
  // if (
  //   (!selectedQueue || Object.keys(selectedQueue).length === 0) &&
  //   tab !== "setting"
  // ) {
  //   return <></>
  // }

  const onFaxNumberChange = (option) => {
    setSelectedQueue({
      ...selectedQueue,
      appId: option.appId,
      customerKey: option.customerKey,
      faxNumber: option.faxNumber,
      userId: option.userId,
    })
  }

  useEffect(() => {
    setSearchText("")
    setSearchBy("")
    setDateRange([])
    setSelectedDate(null)
    setToggleOwnAPPSender(false)
  }, [tab, selectedQueue])

  const optionFilterByFields = filterByFields.map((n) => ({
    value: n.value,
    label: n.label,
  }))

  return (
    <div
      className="fax-list"
      style={{
        flex: `${containerFlex}`,
      }}
    >
      <ul>
        {selectedQueue?.associations && (
          <div style={{ padding: "5px 5px 0 5px" }}>
            <span
              style={{
                fontWeight: "bold",
                backgroundColor: "#BC1B22",
                padding: "10px",
                color: "#FFF",
                border: "1px solid #ccc",
              }}
            >
              {selectedQueue?.queue || ""}
            </span>
            <select
              id="appId"
              className="select-dropdown"
              style={{ width: "200px", marginLeft: "5px" }}
              onChange={(e) => {
                const selected = selectedQueue.associations.find(
                  (a) => a.faxNumber === e.target.value,
                )
                onFaxNumberChange(selected)
              }}
              value={selectedQueue?.faxNumber || ""}
            >
              {selectedQueue?.associations?.map((ass) => (
                <option key={ass.faxNumber} value={ass.faxNumber}>
                  {formatFaxNumber(ass.faxNumber)}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="list-header-container">
          <div className="tabs-container">
            <div
              className="fax-view-tabs"
              style={
                authUser.userRole === "USER" || filteredTabs.length === 1
                  ? { width: "50%" }
                  : { width: "100%" }
              }
            >
              {filteredTabs.map((t) => (
                <div
                  key={t.key}
                  className={`tab ${tab === t.key ? "selected" : ""}`}
                  onClick={() => {
                    handleTabClick(t.key)
                    setReloadKey((prev) => prev + 1)

                    setSearchBy("")
                    setSearchText("")
                    setDateRange([])
                    setSelectedDate(null)
                  }}
                >
                  {/* {t?.icon("black")} */}
                  {selectedQueue?.type === "subfolder" && t.key === "inbound"
                    ? "Copied"
                    : t.label}

                  {t.key === "inbound" &&
                    (selectedQueue?.faxNumber
                      ? ` [${formatFaxNumber(selectedQueue.faxNumber)}]`
                      : "")}

                  {/* {tab === t.key && (
                    <span
                      title="Click to reload faxes"
                      onClick={() => setReloadKey((prev) => prev + 1)}
                      style={{
                        margin: "12px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      <RefreshCcw
                        size={12}
                        color="white"
                        style={{ fontWeight: "bold" }}
                      />
                    </span>
                  )} */}
                </div>
              ))}
            </div>
          </div>

          {(tab === "inbound" || tab === "outbound") && (
            <div className="search-container" style={{ marginRight: "5px" }}>
              {/* {tab === "inbound" && selectedQueue?.type !== "subfolder" && (
                
              )} */}

              {tab === "outbound" &&
                selectedQueue?.faxNumber !== PERSONAL_FAX && (
                  <span
                    title={`Only ${authUser?.netId} Senders`}
                    style={{
                      padding: "0px 10px 0px 8px",
                      cursor: "pointer",
                    }}
                    onClick={() => setToggleOwnAPPSender(!toggleOwnAPPSender)}
                  >
                    <UserCheck
                      size={18}
                      fill={toggleOwnAPPSender ? "#BC1B22" : "white"}
                    />
                  </span>
                )}
              {tab === "inbound" &&
                selectedQueue &&
                selectedQueue?.type !== "subfolder" && (
                  <Select
                    id="roleSelect"
                    placeholder="Search By"
                    className="basic-single"
                    classNamePrefix="select"
                    value={optionFilterByFields.find(
                      (option) => option.value === searchBy,
                    )}
                    onChange={(selectedOption) => {
                      setSearchBy(selectedOption.value)
                      setSearchText("")
                      if (selectedOption.value !== "date") {
                        setDateRange([])
                        setSelectedDate(null)
                      }
                    }}
                    options={optionFilterByFields}
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: 0,
                        width: "180px",
                        height: "40px",
                        marginTop: "0px",
                        marginRight: "5px",
                        boxShadow: "none",
                        borderColor: "#ccc",
                        "&:hover": {
                          borderColor: "#ccc", // consistent border on hover
                        },
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999, // ensures dropdown is on top
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: "grey", // selected value text
                      }),
                    }}
                    menuPortalTarget={document.body} // render menu in body
                    menuPosition="fixed" // avoid clipping inside containers
                    isSearchable
                  />
                )}
              {searchBy === "date" && (
                <div style={{ marginRight: "5px" }}>
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <Flatpickr
                      value={selectedDate} // ✅ must be a single Date object
                      onChange={([date]) => {
                        if (date) {
                          const year = date.getFullYear()
                          const month = date.getMonth()
                          const day = date.getDate()

                          const start = new Date(
                            Date.UTC(year, month, day, 0, 0, 0),
                          )
                          const end = new Date(
                            Date.UTC(year, month, day, 23, 59, 59),
                          )

                          setDateRange([
                            start.toISOString().replace(/\.\d{3}Z$/, "Z"),
                            end.toISOString().replace(/\.\d{3}Z$/, "Z"),
                          ])

                          setSelectedDate(date)
                        }
                      }}
                      options={{
                        mode: "single",
                        //dateFormat: "Y-m-d",
                        dateFormat: "m/d/Y",
                        altInput: false,
                        altFormat: "m/d/Y",
                        minuteIncrement: 15,
                        appendTo: document.body,
                        position: "auto center",
                        maxDate: today,
                        minDate: past180Days,
                        defaultDate: today,
                      }}
                      placeholder="Select date"
                      className="flatpickr-input"
                      style={{ paddingRight: "24px" }}
                    />
                  </div>
                </div>
              )}

              <input
                type="text"
                placeholder={`${
                  tab === "printer"
                    ? "Printer "
                    : ["inbound", "outbound"].includes(tab)
                      ? "Fax "
                      : ""
                }Search...`}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ marginRight: "5px", fontSize: "14px" }}
              />

              {/* <button
                style={{ padding: "9px" }}
                onClick={() => {
                  setSearchButtonFlg(true)
                }}
              >
                Search
              </button> */}
            </div>
          )}
        </div>
        {(tab === "inbound" || tab === "outbound") && (
          <BoundInOut
            selectedQueue={selectedQueue}
            selectedFax={selectedFax}
            setSelectedFax={(fax) => setSelectedFax(fax)}
            tab={tab}
            searchText={searchText}
            searchBy={searchBy}
            reloadQueues={() => reloadQueues()}
            authUser={authUser}
            queueList={queueList}
            allPermissions={allPermissions}
            reloadKey={reloadKey}
            setReloadSubfolderCount={setReloadSubfolderCount}
            dateRange={dateRange}
            // searchButtonFlg={searchButtonFlg}
            setSearchText={setSearchText}
            toggleOwnAPPSender={toggleOwnAPPSender}
            outboundFaxOnlySetting={outboundFaxOnlySetting}
          />
        )}
        {tab === "setting" && (
          <Setting
            authUser={authUser}
            reloadQueues={() => {
              reloadQueues()
            }}
            queueLevelData={queueList?.queueLevelData || []}
          />
        )}
      </ul>
    </div>
  )
}

export default FaxList
